<template>
  <div>
    <TitlePage title="Statistiche Partite"></TitlePage>

    <v-card tile class="mb-4" flat>
      <v-toolbar flat dense>
        <v-toolbar-title class="subtitle-2 font-weight-bold">Filtri</v-toolbar-title>
        <v-spacer />
        <v-btn small color="warning" class="mr-2" to="/match-stats/user-override">
          <v-icon left small>mdi-account-edit</v-icon>
          Override utente
        </v-btn>
        <v-btn small color="error" @click="resetFilters">
          <v-icon left small>mdi-restore</v-icon>
          RESET
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-row class="px-4 pt-3 pb-2 align-center">
        <v-col cols="12" md="3">
          <v-select
            v-model="filters.status"
            :items="statusItems"
            item-text="text"
            item-value="value"
            label="Stato partita"
            dense
            outlined
            hide-details
            clearable
            @change="fetchItems"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              v-model="filters.sport_master"
              :items="sportItems"
              item-text="text"
              item-value="value"
              label="Sport master"
              dense
              outlined
              hide-details
              clearable
              @change="fetchItems"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="filters.code"
            label="Codice partita"
            dense
            hide-details
            outlined
            clearable
            @change="fetchItems"
          />
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end">
          <v-btn color="primary" depressed @click="fetchItems">
            <v-icon left>mdi-magnify</v-icon>
            Cerca
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="text-right caption font-weight-bold pb-1">{{ items_count }} risultati</div>

    <v-data-table
      :headers="headers"
      :items="items"
      item-key="_id"
      class="elevation-1"
      disable-pagination
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:item.start_at="{ item }">
        {{ formatDate(item.start_at) }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip small :color="statusColor(item.status)" dark>{{ statusText(item.status) }}</v-chip>
      </template>

      <template v-slot:item.organizer="{ item }">
        {{ item.organizer_name || '-' }}
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn icon color="primary" :to="'/match-stats/' + item._id" small>
          <v-icon small>mdi-chart-bar</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <div class="d-flex justify-center mt-4">
      <v-pagination
        v-model="page"
        :length="Math.ceil(items_count / limit)"
        :total-visible="7"
        @input="fetchItems"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TitlePage from '@/components/utils/TitlePage';

export default {
  name: 'MatchStatsList',
  components: { TitlePage },
  data() {
    return {
      loading: false,
      items: [],
      items_count: 0,
      page: 1,
      limit: 25,
      sportConfigs: [],
      filters: {
        status: 'finished',
        sport_master: '',
        code: '',
      },
      headers: [
        { text: 'Codice', value: 'code' },
        { text: 'Data', value: 'start_at' },
        { text: 'Sport', value: 'sport_master' },
        { text: 'Stato', value: 'status' },
        { text: 'Organizzatore', value: 'organizer' },
        { text: 'Azioni', value: 'action', sortable: false },
      ],
      statusItems: [
        { text: 'Terminata', value: 'finished' },
      ],
    };
  },
  computed: {
    sportItems() {
      return this.sportConfigs
          .filter(item => item && item.sport_master && item.active !== false)
          .map(item => ({ text: item.sport_master, value: item.sport_master }));
    },
  },
  async created() {
    await this.loadSports();
    await this.fetchItems();
  },
  methods: {
    ...mapActions({
      fetchOpenMatches: 'matches/adminOpen',
      getSportConfigs: 'sportMasterConfig/index',
    }),
    async loadSports() {
      const result = await this.getSportConfigs({ active: true });
      this.sportConfigs = Array.isArray(result) ? result : [];
    },
    async fetchItems() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          limit: this.limit,
        };
        if (this.filters.status) params.status = this.filters.status;
        if (this.filters.code) params.code = this.filters.code;

        const result = await this.fetchOpenMatches(params);
        let rows = (result && result.results) || [];

        if (this.filters.sport_master) {
          const sm = this.filters.sport_master.toLowerCase();
          rows = rows.filter(r => (r.sport_master || '').toLowerCase().includes(sm));
        }

        this.items = rows;
        this.items_count = (result && result.count) || rows.length;
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      this.filters = { status: 'finished', sport_master: '', code: '' };
      this.page = 1;
      this.fetchItems();
    },
    formatDate(d) {
      if (!d) return '-';
      return new Date(d).toLocaleDateString('it-IT', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      });
    },
    statusColor(s) {
      const map = {
        finished: 'blue-grey',
      };
      return map[s] || 'grey';
    },
    statusText(s) {
      const item = this.statusItems.find(status => status.value === s);
      return item ? item.text : (s || '-');
    },
  },
};
</script>
